import { Link as RouterLink, useLocation } from 'react-router-dom';
import { LinkContent } from './components/LinkContent';
import { isLinkActive } from './helpers/isLinkActive';
import { TProps } from './types/TProps';

export const SidebarLink = ({ to, className = 'sidebar-link', text, Icon, iconOffset, activeRoutes }: TProps) => {
  const location = useLocation();

  let active = false;
  activeRoutes.forEach((route) => {
    if (isLinkActive(route, location)) {
      active = true;
    }
  });
  const baseClasses =
    'text-foreground-muted rounded-[5px] flex px-2.5 py-2.5 text-base w-[220px] relative mb-[1px] cursor-pointer no-underline hover:no-underline';
  const hoverClasses = 'hover:bg-surface-muted';
  const activeClasses = active ? '!bg-[var(--color-nav-active-bg)] text-[var(--color-fixed-brand)]' : '';

  return (
    <RouterLink to={to} className={`${baseClasses} ${hoverClasses} ${activeClasses} ${className}`}>
      <LinkContent text={text} Icon={Icon} iconOffset={iconOffset} active={active} />
    </RouterLink>
  );
};
